import React, { useState, useEffect } from 'react';
import { Alert, Row, Col } from 'antd';
import RadioType from './answerTypes/RadioType';
import SelectType from './answerTypes/SelectType';
import TextAreaType from './answerTypes/TextAreaType';
import DateType from './answerTypes/DateType';
import TimeType from './answerTypes/TimeType';

const Question = ({
  test,
  group,
  question,
  questionsLength,
  countGroup,
  groupsLength,
  countQuestion,
  setCountQuestion,
  onChange,
  onReturn,
  buttonsState,
  selectedAnswer,
  answerMissingQuestion,
}) => {
  const [selectedOption, setSelectedOption] = useState();
  let questionOptions;

  if (question.type !== 'textArea' && question.type !== 'text' && question.type !== 'date') {
    questionOptions = question.options;
  }

  const supportedTypes = ['radio', 'select', 'select_multiple', 'textArea', 'text', 'date', 'time'];

  useEffect(() => {
    if (!supportedTypes.includes(question?.type)) {
      if (questionsLength > countQuestion && groupsLength > countGroup) {
        setCountQuestion(countQuestion + 1);
      }
    }
  }, [question?.type]);

  useEffect(() => {
    setSelectedOption(undefined);
  }, [question]);

  const onSubmitAnswer = (type, missingQuestion) => {
    if (type === 'foward') {
      onChange(questionOptions, selectedOption);
    } else if (type === 'previus') {
      onReturn(questionOptions, selectedOption);
    } else if (type === 'unanswered') {
      answerMissingQuestion(missingQuestion.order - 1, questionOptions, selectedOption);
    }
  };

  const getMissingQuestions = () => {
    const _userTest = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};
    const userResponses = _userTest.testsResults
      ? _userTest.testsResults.filter((results) => results.groupId === group.id && results.testId === test.id)
      : [];
    return group.questions.filter(
      (questionGroup) =>
        !userResponses.some((response) => response.questionId === questionGroup.question_id) && questionGroup.question_id !== question.question_id,
    );
  };

  const missingQuestions = () => {
    const missingQuestions = getMissingQuestions();
    let countMissingQuestions = 0;
    return (
      <Row>
        <Col lg={22} md={22}>
          <p>Faltan responder {missingQuestions && missingQuestions.length && missingQuestions.length} preguntas. Algunas son:</p>
        </Col>
        {missingQuestions &&
          missingQuestions.map((missingQuestion, index) => {
            countMissingQuestions++;
            if (countMissingQuestions <= 12) {
              return (
                <Col key={index} md={8}>
                  <p>
                    <a onClick={(e) => onSubmitAnswer('unanswered', missingQuestion)}>Pregunta N° {missingQuestion.order && missingQuestion.order}</a>
                  </p>
                </Col>
              );
            }
          })}
      </Row>
    );
  };

  return (
    <Row justify="center" className="question-container mt-80">
      <Col lg={22} md={22}>
        <Row justify="space-between">
          <Col>
            <p>{group && group.name}</p>
          </Col>
          <Col>
            <p>
              Pregunta {countQuestion + 1} de {questionsLength}
            </p>
          </Col>
        </Row>
        {question && question.type === 'radio' && (
          <RadioType
            question={question}
            options={questionOptions && questionOptions}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        )}
        {question && question.type === 'select' && (
          <SelectType
            question={question}
            options={questionOptions && questionOptions}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            isMultiple={false}
          />
        )}
        {question && question.type === 'select_multiple' && (
          <SelectType
            question={question}
            options={questionOptions && questionOptions}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            isMultiple={true}
          />
        )}
        {question && question.type === 'date' && (
          <DateType
            question={question}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        )}
        {question && question.type === 'time' && (
          <TimeType
            question={question}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        )}
        {question && (question.type === 'textArea' || question.type === 'text') && (
          <TextAreaType
            question={question}
            selectedAnswer={selectedAnswer}
            buttonsState={buttonsState}
            onSubmitAnswer={onSubmitAnswer}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        )}
        {buttonsState.reachedLast && buttonsState.questionsUnanswered && getMissingQuestions().length > 0 && (
          <Row className="mb-40">
            <Alert message="" description={missingQuestions()} type="error" showIcon />
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default Question;
